module.exports = __webpack_public_path__ + "img/audio-mark5.a3846170.png";